<template>
  <div>
    <template>
      <loader-text title="Connexion à la plateforme candidat ICDL" />
    </template>
  </div>
</template>

<script>
  import LoaderText from '@/components/loader-text';

  export default {
    name: 'SmartLogin',
    components: {
      LoaderText
    },
    data(){
      return{
        token:null
      }
    },
    mounted() {

      this.$ajax.smartLogin(this.$route.params.token).then(() => {
        //console.debug(this.user());
        this.$nextTick(this.$router.push({ name: 'dashboard' }));
      }).catch((err) => {
        if (err.response && err.response.data) {
          this.$nextTick(this.$router.push({ name: 'login' }));
          this.$notify({
            title: this.$t('flashes.login.title'),
            text: this.$t(`flashes.login.${err.response.data.error}`),
            type: 'error',
          });
        }
      });
      // No Token and No User, wait form submit.
    },
    methods: {
      loggingWithToken() {

        this.$ajax.loggingByToken({"token":"token_player_dev"}).then(() => {
          console.debug(this.user())
          this.$helper.setLocale(this.user() ? this.user().preferred_locale : window.navigator.language);
          this.$nextTick(this.forwardToDashboard());
        });
      },
      forwardToDashboard() {
        this.$router.push({ name: 'dashboard' });
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  h1,
  h2 {
    border-bottom: 2px solid;
    padding-bottom: 1rem;
  }

  h1 {
    border-bottom-color: $light-grey;
  }

  h2 {
    border-bottom-color: $primary;
  }

  .intro {
    margin: 2rem 0;
    color: $secondary;
  }

  .know-more-link {
    padding: 0;
    font-size: 0.8rem;
    margin-bottom: 1rem;
  }

  .text {
    color: $grey;
    font-size: 0.8rem;
  }

  .login-form {
    position: relative;
    padding-bottom: 30px;

    .btn-fixed-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
</style>
